import React from 'react';
import { TableCell, TableHead, TableRow } from '@material-ui/core';

import { useStyles } from './styles';

const headers: string[] = [
  'Visualizar histórico',
  'Número Pedido',
  'ID Prod',
  'Cód Numérico',
  'Descrição',
  'Cor',
  'Dt Emis',
  'Dt Orig',
  'Dt Agenda',
  'Status'
];

export const OrdersTableHead = () => {
  const classes = useStyles();

  return (
    <TableHead>
      <TableRow className={classes.tableHeadRow}>
        {headers.map((header, i) => (
          <TableCell
            key={i}
            className={classes.tableHeadCell}
            style={{
              minWidth: header === 'Descrição' ? '350px' : '165px'
            }}
          >
            {header}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};
